module.exports = __webpack_public_path__ + "img/baum-splashimage.acb65410.png";